import React, { FC, useMemo } from "react";
import { ScreenProps } from "../../typings";
import { DashboardView as IDashboardView } from "@data-root/types";
import { Layout, Tabs } from "antd";
import {
  useAppContext,
  resolveViewComponent,
  ViewProvider,
} from "@data-root/react";

const { Content } = Layout;

export const MobileDashboardView: FC<ScreenProps<IDashboardView>> = ({
  view,
}) => {
  const { options } = view;
  const { layouts } = options;

  const { getView } = useAppContext();

  const views = useMemo(
    () => layouts.map((layout) => getView(layout.viewId)),
    [getView, layouts]
  );

  const components = useMemo(
    () => views.map((view) => resolveViewComponent(view.type)),
    [views]
  );

  const children = useMemo(
    () =>
      views.map((view, i) => {
        const Component = components[i];
        return (
          <ViewProvider view={view}>
            <Component view={view} />
          </ViewProvider>
        );
      }),
    [views, components]
  );

  return (
    <Layout>
      <Content>
        <Tabs
          items={views.map((view, i) => ({
            key: view.id,
            label: view.name,
            forceRender: true,
            children: children[i],
          }))}
        />
      </Content>
    </Layout>
  );
};
